const cols = [
  {
    title: '时间',
    key: 'title',
    type: 'basic',
    fixed: true,
    width: 108
  },
  {
    title: '广告计划名称',
    key: 'planName',
    type: 'basic',
    fixed: true,
    width: 136
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    fixed: true,
    type: 'basic',
    width: 82
  },
  {
    title: '媒体',
    key: 'mediaName',
    fixed: true,
    type: 'basic',
    width: 92
  },
  {
    title: '媒体素材ID',
    key: 'mediaMaterialId',
    overflow: true,
    fixed: true,
    type: 'basic',
    width: 92
  },
  {
    title: '展示',
    key: 'pv',
    sortable: 'custom',
    type: 'basic',
    width: 68
  },
  {
    title: '点击',
    key: 'clickNum',
    sortable: 'custom',
    type: 'basic',
    width: 68
  },
  {
    title: '点击率',
    key: 'clickRate',
    type: 'basic',
    width: 56
  },
  {
    title: '账面消耗',
    key: 'paperUseAmount',
    sortable: 'custom',
    type: 'basic',
    width: 88
  },
  {
    title: '实际消耗',
    key: 'amount',
    sortable: 'custom',
    type: 'basic',
    width: 88
  },
  {
    title: '激活数',
    key: 'downNum',
    sortable: 'custom',
    type: 'basic',
    width: 72
  },
  {
    title: '创角数',
    key: 'createRoleNum',
    sortable: 'custom',
    type: 'basic',
    width: 72
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    sortable: 'custom',
    type: 'basic',
    width: 82
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    sortable: 'custom',
    type: 'basic',
    width: 108
  },
  {
    title: '新创角充值金额',
    key: 'newRoleMoney',
    sortable: 'custom',
    type: 'basic',
    width: 124
  },
  {
    title: '新创角回款率',
    key: 'newRoleRate',
    type: 'basic',
    width: 88
  },

  {
    title: '创角账号24H付费金额',
    key: 'createRole24hPayMoney',
    type: 'basic',
    sortable: 'custom',
    width: 98,
    checked: false
  },

  {
    title: '创角账号24HROI',
    key: 'createRole24hRoi',
    type: 'report',
    sortable: 'custom',
    width: 98,
    checked: false
  },
  {
    title: '1日ROI',
    key: 'createRoleRoi1d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },

  {
    title: '3日ROI',
    key: 'createRoleRoi3d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },

  {
    title: '7日ROI',
    key: 'createRoleRoi7d',
    type: 'report',
    sortable: 'custom',
    width: 88
  },

  {
    title: '激活次留',
    key: 'nextDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '激活3留',
    key: 'threeDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '激活7留',
    key: 'sevenDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '激活30留',
    key: 'thirtyDayRetainRate',
    type: 'report',
    width: 62
  },
  {
    title: '创角次留',
    key: 'createRoleTwoDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角3留',
    key: 'createRoleThreeDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角4留',
    key: 'createRoleFourDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角5留',
    key: 'createRoleFiveDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角6留',
    key: 'createRoleSixDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角7留',
    key: 'createRoleSevenDayRetainRate',
    type: 'report',
    width: 58
  },
  {
    title: '创角10留',
    key: 'createRoleTenDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角15留',
    key: 'createRoleFifteenDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角30留',
    key: 'createRoleThirtyDayRetainRate',
    type: 'report',
    width: 68
  },
  {
    title: '创角1日LTV',
    key: 'createRoleOneDayLtv',
    type: 'other',
    width: 74
  },
  {
    title: '创角2日LTV',
    key: 'createRoleTwoDayLtv',
    type: 'other',
    width: 74
  },
  {
    title: '创角3日LTV',
    key: 'createRoleThreeDayLtv',
    type: 'other',
    width: 74
  },
  {
    title: '创角4日LTV',
    key: 'createRoleFourDayLtv',
    type: 'other',
    width: 74
  },
  {
    title: '创角5日LTV',
    key: 'createRoleFiveDayLtv',
    type: 'other',
    width: 74
  },
  {
    title: '创角6日LTV',
    key: 'createRoleSixDayLtv',
    type: 'other',
    width: 74
  },
  {
    title: '创角7日LTV',
    key: 'createRoleSevenDayLtv',
    type: 'other',
    width: 74
  },
  {
    title: '创角10日LTV',
    key: 'createRoleTenDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角15日LTV',
    key: 'createRoleFifteenDayLtv',
    type: 'other',
    width: 82
  },
  {
    title: '创角30日LTV',
    key: 'createRoleThirtyDayLtv',
    type: 'other',
    width: 82
  }
]
// 新素材统计的计划数据详情和素材分析的广告数据公用一个表格列
// 新素材统计的计划数据详情不需要展示媒体素材ID
export const reportCols = cols.filter((col) => col.title !== '媒体素材ID')
export const analysisCols = cols.filter((col) => !['激活次留', '激活3留', '激活7留', '激活30留'].includes(col.title))
